import React, {useEffect, useState} from "react";
import CardExpiration from "../../Components/Forms/CardExpiration";
import CustomCheckbox from "../../Components/CustomCheckBox";
import {withButtonLoader} from "../../helpers";
import "./CreditCardManualNmiFields.css";

const CreditCardManualNmiFields = (
    {
        paymentType,
        handleInputChange,
        handleSubmit,
        isPaymentSaveDetails,
        setIsPaymentSaveDetails,
        isDefault,
        setIsDefault,
        transactionLoading,
        buttonText,
        selectedAmount,
        forceDisableAndCheck = false,
        manual,
        showResult,
    }) => {


    return (
        <div
            className={`tab-pane ${paymentType === "creditCard" || paymentType === "hhaCard" ? "fade show active" : ""}`}
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
        >
            <div className="sos-content payment-inner-toggleable">
                <form id='creditCardForm'>

                    <div className="form-group mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label payment-form-label">
                            Cardholder Name
                        </label>
                        <div className="row g-2">
                            <div className="col-md">
                                <div className="payment-controlpanl-style">
                                    <input
                                        type="text"
                                        name="cardFirstName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="First Name"
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div>
                                    <input
                                        type="text"
                                        name="cardLastName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="Last Name"
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='payment-fields'>


                        <div className="form-group mb-3">
                            <label htmlFor="exampleInputPassword1" className="form-label payment-form-label">
                                Credit Card Number
                            </label>
                            <div id='ccNumberInput'></div>
                            {/*<input*/}
                            {/*    type="tel"*/}
                            {/*    name="cardnumber"*/}
                            {/*    className="form-control custom-input-border-css"*/}
                            {/*    placeholder="Enter Credit Card Number"*/}
                            {/*    pattern="[\d| ]{15,22}"*/}
                            {/*    required*/}
                            {/*    onChange={(e) => handleInputChange(e)}*/}
                            {/*/>*/}
                        </div>

                        <div className="row g-2">
                            <div className="col-md">
                                <div className="payment-controlpanl-style">
                                    <div>
                                        <label className="payment-form-label">Expiry Date</label>
                                    </div>
                                    {/*<CardExpiration onChange={(e) => handleInputChange(e)}></CardExpiration>*/}
                                    <div id='ccExpInput'>
                                        {/*<input*/}
                                        {/*    type="tel"*/}
                                        {/*    className="form-control custom-input-border-css bg-white"*/}
                                        {/*    id="expiry"*/}
                                        {/*    placeholder="mm/yy"*/}
                                        {/*    name="expiry"*/}
                                        {/*    pattern="\d\d/\d\d"*/}
                                        {/*    required*/}
                                        {/*    onChange={(e) => formatExpirationDate(e)}*/}
                                        {/*    onBlur={(e) => handleInputChange(e)}*/}
                                        {/*/>*/}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md">
                                <div>
                                    <div>
                                        <label className="payment-form-label">Security Code</label>
                                    </div>
                                    <div id='cvvInput'></div>
                                    {/*<input*/}
                                    {/*    type="tel"*/}
                                    {/*    className="form-control custom-input-border-css"*/}
                                    {/*    placeholder="Enter CVC"*/}
                                    {/*    name="cvc"*/}
                                    {/*    pattern="\d{3,4}"*/}
                                    {/*    required*/}
                                    {/*    onChange={(e) => handleInputChange(e)}*/}
                                    {/*/>*/}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group mb-3">
                        <label className="form-label payment-form-label">Zip (optional)</label>
                        <input
                            type="text"
                            inputMode="numeric"
                            name="billingZip"
                            className="form-control custom-input-border-css"
                            placeholder="Zip Code"
                            onChange={(e) => handleInputChange(e)}
                            maxLength={10}
                        />
                    </div>

                    <div className="checkbox-list mt-3">
                        <label className={`label-check font-weight-light float-end ${
                            (selectedAmount === "" || forceDisableAndCheck) ? "disabled-label" : ""
                        }`}>
                            <CustomCheckbox
                                id="isPaymentSaveDetails"
                                name="isPaymentSaveDetails"
                                disabled={selectedAmount === "" || forceDisableAndCheck}
                                checked={(selectedAmount === "" || forceDisableAndCheck) ? true : isPaymentSaveDetails}
                                onChange={(e) => setIsPaymentSaveDetails(!isPaymentSaveDetails)}
                            />
                            Save these payment details for future payments
                        </label>
                        <div className="payment-checbox">
                            <label className="font-weight-light label-check ml-xl-5">
                                <CustomCheckbox
                                    id="isDefault"
                                    name="isDefault"
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(!isDefault)}
                                />
                                Set as default payment method
                            </label>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center">
                        <button
                            id='submitPayButton'
                            type="button"
                            className="sos-mack-btn sos-custom-btn-css"
                            disabled={transactionLoading}
                            onMouseDown={(e)=>{
                                console.log('onMouseDown happened #k3n8d9f2h5w7');
                                console.dir(e);
                                console.log(`manual: ${manual}, paymentType: ${paymentType} #m9x4t7q2n6p1`);

                                // Don't check paymentType - this component is ONLY for credit cards
                                if (manual) {
                                    // Use setTimeout to let CollectJS validation run first
                                    setTimeout(() => {
                                        console.log('Checking validation errors... #z5r8j3v1b4k9', manual.validationErrors);
                                        const validationCheck = manual.checkValidationErrors();
                                        console.log('Validation check result #w2h6y9l4s8f3', validationCheck);
                                        console.log('Checking if validationCheck.hasErrors #a7d3x9c2m5q8');
                                        if (validationCheck.hasErrors) {
                                            console.log('Has errors, calling showResult #p1t4n8r6j2v9');
                                            if (showResult) {
                                                console.error(`validationCheck.error #sndj2k3j`);
                                                console.error(validationCheck.error);
                                                showResult("error", validationCheck.error);
                                            } else {
                                                console.error(validationCheck.error.message);
                                                console.error(`validationCheck.error.message #sndj2837`);
                                                alert(validationCheck.error.message);
                                            }
                                        }
                                    }, 200); // Wait for CollectJS to validate
                                }
                                return true;
                            }}
                        >
                            {withButtonLoader(buttonText, transactionLoading)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreditCardManualNmiFields;
